











import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'FSlider',
  props: {},
  setup() {
    const agileOptions = {
      navButtons: false,
      infinite: false,
      dots: true,
      speed: 800,
      slidesToShow: 1,
    }
    return { agileOptions }
  },
})
